import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableItem = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    width: "100px",
    height: "100px",
    border: "2px solid red",
    backgroundColor: "#cccccc",
    margin: "10px",
    zIndex: isDragging ? "100" : "auto",
    opacity: isDragging ? 0.3 : 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex flex-col items-center justify-center"
    >
      <button
        {...listeners}
        {...attributes}
        className="p-2 bg-gray-300 border border-gray-500 rounded"
      >
        Drag handle
      </button>
      <div className="min-w-[30px] min-h-[20px] border border-black text-center mt-2">
        {props.value}
      </div>
    </div>
  );
};

export default SortableItem;
